import { Spacer } from '@lux/tokens';
import styled from 'styled-components';

export const CarouselContainer = styled.div`
    padding-bottom: ${Spacer.L};
`;
